import { OapStatusCode } from "@taskflow/contracts";

import type { BoardTag } from "./api";

/** Вариант выбора: веб и приложение рисуют его своими компонентами. */
export interface StatusOption {
  id: string;
  label: string;
}

/** §29.1: порядок статусов — порядок работы, а не алфавит. */
const ORDER: readonly string[] = [
  OapStatusCode.PLANNED,
  OapStatusCode.IN_PROGRESS,
  OapStatusCode.ON_CONTROL,
  OapStatusCode.COMPLETED,
];

/**
 * Системные статусы доски «проект на столбце» для ручного выбора.
 * Обычные теги сюда не попадают: §10.2 запрещает назначать статус тегом.
 */
export function systemStatusOptions(tags: readonly BoardTag[] | undefined): StatusOption[] {
  return (tags ?? [])
    .filter((tag) => tag.kind === "SYSTEM_STATUS")
    .sort((a, b) => ORDER.indexOf(a.systemCode ?? "") - ORDER.indexOf(b.systemCode ?? ""))
    .map((tag) => ({ id: tag.id, label: tag.name }));
}

export function plannedStatusId(tags: readonly BoardTag[] | undefined): string | null {
  return (
    tags?.find((tag) => tag.kind === "SYSTEM_STATUS" && tag.systemCode === OapStatusCode.PLANNED)
      ?.id ?? null
  );
}

/** Категории статуса для отчётности (§17.4): по ним считаются KPI.
 *  Одна таблица для создания доски, настроек столбцов и карточки задачи. */
export const STATUS_CATEGORIES: readonly StatusOption[] = [
  { id: "OPEN", label: "Открыто" },
  { id: "IN_PROGRESS", label: "В работе" },
  { id: "DONE", label: "Выполнено" },
  { id: "CLOSED", label: "Закрыто" },
];
